import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormDefinition, FormFieldDefinition } from '@nuso/forms/data-access';

@Injectable({
  providedIn: 'root',
})
export class IamGroupSharedService {
  private router = inject(Router);

  groupFormDef: FormDefinition;
  groupAddUserFormDef: FormDefinition;
  groupUpdateUserFormDef: FormDefinition;

  constructor() {
    this.assignGroupFormDef();
    this.assignGroupUserFormDef();
  }

  private assignGroupFormDef() {
    this.groupFormDef = {
      name: 'iam-group-form',
      fields: [
        {
          name: 'id',
          label: 'Id',
          type: 'hidden',
        },
        {
          name: 'name',
          label: 'Name',
          type: 'text',
          validators: { required: true },
        },
        {
          name: 'description',
          label: 'Description',
          type: 'text',
        },
      ],
    };
  }

  private assignGroupUserFormDef() {
    this.groupAddUserFormDef = {
      name: 'iam-group-add-user-form',
      fields: [
        {
          name: 'users',
          label: 'User',
          type: 'multiple-search-select',
          options: [],
          validators: { required: true },
        },
      ],
    };

    this.groupUpdateUserFormDef = {
      name: 'iam-group-update-user-form',
      fields: [
        {
          name: 'users',
          label: 'User',
          type: 'type',
          enableIf: {
            users: false,
          },
        },
        {
          name: 'member',
          label: 'Member',
          type: 'checkbox',
          defaultTo: true,
        },
        {
          name: 'supervisor',
          label: 'Supervisor',
          type: 'checkbox',
        },
      ],
    };
  }
}
